import { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import { ISLAND_BY_CODE } from "../../lib/caribbeanIslands";
import "leaflet/dist/leaflet.css";

const defaultIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

function MapClickHandler({ onPick }) {
  useMapEvents({
    click(e) {
      onPick({ lat: e.latlng.lat, lng: e.latlng.lng });
    },
  });
  return null;
}

export default function PartnerMapPicker({ country = "barbados", lat, lng, onChange }) {
  const island = ISLAND_BY_CODE[country] || ISLAND_BY_CODE.barbados;
  const center = useMemo(
    () => (lat != null && lng != null ? [lat, lng] : [island.center.lat, island.center.lng]),
    [lat, lng, island]
  );

  useEffect(() => {
    if (lat == null || lng == null) {
      onChange({ lat: island.center.lat, lng: island.center.lng });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reset only when island changes
  }, [country]);

  return (
    <div className="w-full max-w-full rounded-[1.5rem] border border-cyan-100 overflow-hidden">
      <MapContainer
        center={center}
        zoom={island.zoom}
        style={{ height: "200px", width: "100%" }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapClickHandler onPick={onChange} />
        {lat != null && lng != null && <Marker position={[lat, lng]} icon={defaultIcon} />}
      </MapContainer>
      <p className="text-xs text-slate-500 px-3 py-2 bg-slate-50">
        Tap the real map to set your business location ({lat?.toFixed(4)}, {lng?.toFixed(4)})
      </p>
    </div>
  );
}
